var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFlagged(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 5,
    height: 6,
    viewBox: "0 0 5 6",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.99849 0.873332C4.99849 0.803226 4.95974 0.738877 4.89818 0.705762C4.83662 0.672761 4.76139 0.676693 4.70325 0.715508C4.69299 0.721721 3.687 1.38009 3.04579 0.738877C2.34815 0.0411799 1.34273 0.419638 0.907841 0.716591C0.855974 0.751929 0.825195 0.810636 0.825195 0.873332V5.42572C0.825195 5.53059 0.91012 5.61546 1.01499 5.61546C1.11987 5.61546 1.20479 5.53059 1.20479 5.42572V3.44394C1.45615 3.29626 2.22617 2.92179 2.7779 3.47295C3.45958 4.15463 4.47241 3.78757 4.913 3.49746C4.96601 3.46212 4.99849 3.40285 4.99849 3.33901V0.873332Z",
    fill: "#ED8B00"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlagged);
export default __webpack_public_path__ + "static/media/flagged.0bc3937522ca77d15ae6f4c9e0cd1e3c.svg";
export { ForwardRef as ReactComponent };